export default {
  welcome: 'Bienvenida',
  we_miss_you: 'Te echamos de menos',
  happy_friday: 'Feliz viernes',
  lazy_sunday: 'Domingo tranquilo',
  loyalty_program: 'Programa de fidelidad',
  you_might_also_like: 'También te puede gustar',
  storefront_promo: 'Promo de tienda',
  welcome_members_club: 'Bienvenida al club',
  launch_deal: 'Oferta de lanzamiento',
};
